export const RULE_BUILDER_NODE_AND_COLOR = "#FFD8A8";
export const RULE_BUILDER_NODE_OR_COLOR = "#C7EAFF";
export const RULE_BUILDER_EDGE_AND_COLOR = "#FFB963";
export const RULE_BUILDER_EDGE_OR_COLOR = "#6CC7FF";

export const ANALYTICS_HEATMAP_MIN_COLOR = "#E9F4FF";
export const ANALYTICS_HEATMAP_MAX_COLOR = "#043A6B";
